import { useLingui } from '@lingui/react/macro'
import {
  DocChatSearchBox,
  type DocChatSearchBoxProps,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/components/search/DocChatSearchBox'
import type { DocChatTurn } from 'features/knowledgeDocumentViewer/types'
import React from 'react'
import styled from 'styled-components'

import { DocChatMessageQueue } from './DocChatMessageQueue'
import { DocChatTimeline } from './DocChatTimeline'

const HeaderRoot = styled.div`
  position: relative;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
  flex-shrink: 0;
  background: var(--sidebar);
  border-bottom: 0.0625rem solid var(--border);
`

const InputRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  width: 100%;
  padding-right: 0.5rem;
  flex-shrink: 0;
`

interface DocChatResultsHeaderProps extends Omit<
  DocChatSearchBoxProps,
  'placeholder'
> {
  turns: DocChatTurn[]
}

export function DocChatResultsHeader({
  turns,
  ...searchBoxProps
}: DocChatResultsHeaderProps): React.ReactElement {
  const { t } = useLingui()
  return (
    <HeaderRoot>
      <DocChatTimeline turns={turns} />
      <InputRow>
        <DocChatMessageQueue />
        <DocChatSearchBox
          {...searchBoxProps}
          placeholder={t`Ask Cantilever...`}
        />
      </InputRow>
    </HeaderRoot>
  )
}
